import {
    ITipoPerguntaFormularios,
    IListarPerguntasERespostasForm,
    IEditarPerguntasERespostasForm,
} from "../../../../Interfaces/Geral/Formularios/FormulariosInterface";
import Axios from "../../../Config/API";
import Service from "../../../Service";

export async function DeletarPerguntaPesquisaServices(
    idPesquisaSatisfacaoPergunta: number
) {
    return Service(
        Axios.delete(
            `/home/pesquisasatisfacaopergunta/deletarpesquisasatisfacaopergunta?idPesquisaSatisfacaoPergunta=${idPesquisaSatisfacaoPergunta}`
        )
    );
}

export async function ListarTipoPerguntaFormularioServices() {
    return Service(
        Axios.get<Array<ITipoPerguntaFormularios>>(
            `/home/pesquisasatisfacaotipopergunta/listarpesquisasatisfacaotipopergunta`
        )
    );
}
export async function ListarPerguntasERespostarFormServices(
    idFormulario: number
) {
    return Service(
        Axios.get<IListarPerguntasERespostasForm>(
            `/home/pesquisasatisfacaoperguntaresposta/listarformularioperguntarespostas?idFormulario=${idFormulario}`
        )
    );
}

export async function EditarPerguntasERespostasServices(
    requestBody: IEditarPerguntasERespostasForm
) {
    return Service(
        Axios.put(
            `/home/pesquisasatisfacaoperguntaresposta/atualizarformularioperguntarespostas`,
            requestBody
        )
    );
}

export async function CadastrarPerguntasERespostasServices(
    requestBody: IEditarPerguntasERespostasForm
) {
    return Service(
        Axios.post(
            `/home/pesquisasatisfacaoperguntaresposta/cadastrarperguntaresposta`,
            requestBody
        )
    );
}
